export default __webpack_public_path__ + "static/media/video.b60f0d7a.mp4";